<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button
          type="primary"
          v-if="isHavePermission('buyer:createContract')"
          icon="ios-add"
          @click="showDialog"
      >新建合同
      </Button>
      <vxe-button
          icon="vxe-icon--refresh"
          @click="refresh"
          :style="
          !isHavePermission('buyer:createContract') ? '' : 'margin-left: 20px'
        "
      >刷新
      </vxe-button>
      <Button
          icon="md-download"
          @click="download"
          style="margin-left: 10px"
          v-if="isHavePermission('agreement:buyer:download')"
      >导出
      </Button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同号" field="numb" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.numb"
                      placeholder="输入合同号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务类型" field="busType" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.busType"
                      :options="busTypeOption"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单标题" field="title" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.title"
                      placeholder="输入订单标题"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人名称" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchBuyerName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'buyerNameOptions',
                          'agreement',
                          'queryContractKeyword',
                          1,
                          1
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'buyerNameOptions')
                    "
                      placeholder="输入托运人"
                  >
                    <Option
                        v-for="option in buyerNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人名称" field="sellerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="
                      (file) =>
                        remoteMethod(
                          file,
                          'sellerNameOptions',
                          'agreement',
                          'queryContractKeyword',
                          2,
                          1
                        )
                    "
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="
                      (file) => setDefaultOptions(file, 'sellerNameOptions')
                    "
                      placeholder="输入承运人"
                  >
                    <Option
                        v-for="option in sellerNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="附件筛查" field="hasFile" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.hasFile"
                      :options="fileOptions"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.createUser"
                      placeholder="输入创建人"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      type="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button
                      @click="reset"
                      style="margin-left: 10px; border-radius: 5px"
                  >重置
                  </Button
                  >
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          show-overflow
          max-height="740"
          :loading="loading"
          :data="tableData"
      >
        <vxe-table-column field="id" title="序号" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                v-if="
                isHavePermission('buyer:updateContract') ||
                isHavePermission('buyer:removeContract')
              "
                trigger="click"
                style="margin-left: 10px; cursor: pointer"
                transfer
            >
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      v-if="isHavePermission('buyer:updateContract')"
                      @click="openEditView(row.id)"
                  >编辑
                  </Button>
                  <Button
                      class="button-gengduo"
                      v-if="isHavePermission('buyer:removeContract')"
                      @click="commitDelete(row.id)"
                      style="color: #ed4014"
                  >删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="numb" title="合同号" width="150">
          <template slot-scope="{ row }">
            <span
                v-if="isHavePermission('buyer:queryContractDetail')"
                @click="showDetail(row.id)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.numb }}</span
            >
            <span v-if="!isHavePermission('buyer:queryContractDetail')">{{
              row.numb
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="title"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column field="busType" title="业务类型" width="60">
          <template slot-scope="{ row }">
            <span>{{ row.busType | contractbusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addWay" title="签约方式" width="85">
          <template slot-scope="{ row }">
            <span>{{ row.addWay | signType }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期" width="140">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsList">{{
              row.goodsList[0].addTime | timeFormatDate
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click="clickEvent3($rowIndex)"
                v-if="row.goodsList && row.goodsList.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 1330px"
                      :data="row.goodsList"
                      stripe
                      show-overflow
                      align="center"
                      max-height="480"
                      :show-header="false"
                  >
                    <vxe-table-column
                        field="addTime"
                        title="签约日期"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.addTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="105"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="packUnit"
                        title="包装形式"
                        width="80"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="price"
                        title="单价"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="amount"
                        title="总金额"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="priceType"
                        title="计费方式"
                        width="80"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.priceType | priceTypeMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        {{ row.isTax | taxMap }}
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="120"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="endTime"
                        title="到达时间"
                        width="140"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.endTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsName"
            title="货名"
            width="105"
        ></vxe-table-column>
        <vxe-table-column
            field="packUnit"
            title="包装形式"
            width="80"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="60"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="amount"
            title="总金额"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="goodsRtnVos"
            title="计费方式"
            width="80"
            align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.priceType | priceTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="60">
          <template slot-scope="{ row }">
            {{ row.isTax | taxMap }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120">
          <template slot-scope="{ row }">
            <div v-if="isHavePermission('buyer:getMap')">
              <span
                  v-if="row.trackUrl || row.transportationType === 2"
                  @click="getMap(row)"
                  style="color: #2d8cf0; cursor: pointer"
              >{{ row.carShipNum }}</span
              >
              <span v-if="!row.trackUrl && row.transportationType !== 2">{{
                row.carShipNum
              }}</span>
            </div>
            <span v-if="!isHavePermission('buyer:getMap')">{{
              row.carShipNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="客户经理"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createTime"
            title="创建日期"
            width="120"
            v-if="isHavePermission('global:viewCreateTime')"
        >
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{
              row.createTime | timeFormatDate
            }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div v-show="trackFlag" class="trackBox">
      <div style="display: flex; justify-content: space-between">
        <div
            style="
            margin-left: 10px;
            font-size: 14px;
            font-weight: bold;
            line-height: 30px;
          "
        >
          {{ isCar ? "车辆轨迹" : "船舶轨迹" }}
        </div>
        <div
            @click="trackFlag = false"
            style="
            margin-right: 82px;
            cursor: pointer;
            line-height: 30px;
            height: 30px;
            background: #409eff;
            color: #fff;
            border-radius: 5px;
            width: 60px;
            font-size: 12px;
            font-size: 12px;
            text-align: center;
          "
        >
          关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width: 100%; height: 85vh; overflow: hidden"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
    </div>
    <vxe-modal
        v-model="visible"
        :title="modalTitle"
        width="1300"
        height="660"
        @close="closeCreate"
        resize
        position="center"
    >
      <create-buyer-modal ref="modalCreate" @close="close"></create-buyer-modal>
    </vxe-modal>
    <vxe-modal
        v-model="viewBuyer"
        title="查看托运人合同"
        width="1300"
        height="660"
        @close="closeDetail"
        resize
        position="center"
    >
      <view-detail-modal ref="modalDetail" @goEdit="goEdit"></view-detail-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import CreateBuyerModal from "./CreateBuyerModal";
  import ViewDetailModal from "./ViewDetailModal";
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import Auth from "@/utils/auth.js";
  import {searchTime, SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {
    getBlob,
    hideLoading,
    saveBlob,
    showLoading,
    isEmpty,
  } from "@/utils/util";

  moment.locale("zh-CN");

  export default {
    name: "Buyer",
    components: {CreateBuyerModal, ViewDetailModal},
    mixins: [getAuthOrization],
    data() {
      return {
        searchLoading: false,
        searchVisible: false,
        open: false,
        busTypeOption: [],
        fileOptions: $C.HAS_FILE_TYPE.options,
        timeOptions: SEARCH_TIME.options,
        contractId: "",
        trackFlag: false,
        url: "",
        isCar: true,
        visible: false,
        loading: false,
        modalTitle: "",
        tableData: [],
        searchBuyerName: [],
        searchSellerName: [],
        buyerNameOptions: [],
        sellerNameOptions: [],
        searchFormData: {
          numb: null,
          addTime: null,
          busType: null,
          title: null,
          buyerName: null,
          sellerName: null,
          goodsName: null,
          carShipNum: null,
          createUser: null,
          createTime: null,
          hasFile: null,
        },
        searchFormItems: [
          {
            title: "搜索",
            span: 24,
            titleAlign: "left",
            titleWidth: 200,
          },
          {
            field: "numb",
            title: "合同号",
            span: 12,
            titleAlign: "left",
            itemRender: {
              name: "$input",
              props: {placeholder: "输入合同号"},
            },
          },
          {
            field: "busType",
            title: "按业务类型",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择业务类型", transfer: false},
              options: $C.CONTRACTBUS_TYPE.options,
            },
          },
          {
            field: "title",
            title: "订单标题",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入订单标题"},
            },
          },
          {
            field: "buyerName",
            title: "托运人名称",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入托运人名称"},
            },
          },
          {
            field: "sellerName",
            title: "承运人名称",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入承运人名称"},
            },
          },
          {
            field: "goodsName",
            title: "货名",
            titleAlign: "left",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入货名"}},
          },
          {
            field: "carShipNum",
            title: "车船号",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入车船号"},
            },
          },
          {
            field: "hasFile",
            title: "附件筛查",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择是否包含附件", transfer: false},
              options: $C.HAS_FILE_TYPE.options,
            },
          },
          {
            field: "createUser",
            title: "创建人",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入创建人"},
            },
          },
          {
            field: "createTime",
            title: "按创建时间",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择时间", transfer: false},
              options: SEARCH_TIME.options,
            },
          },
          {
            align: "right",
            span: 24,
            titleAlign: "left",
            itemRender: {
              name: "$buttons",
              children: [
                {props: {type: "submit", content: "提交", status: "primary"}},
                {props: {type: "reset", content: "重置"}},
              ],
            },
          },
        ],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        paramsObj: {
          type: 1,
          orderBy: 2,
          page: 1,
          rows: 10,
        },
        viewBuyer: false,
      };
    },
    watch: {
      "searchFormData.createTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("createTime");
        },
      },
    },
    mounted() {
      this.$bus.$on("托运人合同", () => {
        this.reset();
        this.getSearchListKey();
      });
      this.getList(
        "",
        "buyerNameOptions",
        "agreement",
        "queryContractKeyword",
        1,
        1
      );
      this.getList(
        "",
        "sellerNameOptions",
        "agreement",
        "queryContractKeyword",
        2,
        1
      );
      this.queryContractList();
      this.getDicContractBusType();
    },
    methods: {
      reset() {
        this.searchFormData = {
          numb: null,
          addTime: null,
          busType: null,
          title: null,
          buyerName: null,
          sellerName: null,
          goodsName: null,
          carShipNum: null,
          createUser: null,
          createTime: null,
          hasFile: null,
        };
        this.searchBuyerName = [];
        this.searchSellerName = [];
        this.getList(
          "",
          "buyerNameOptions",
          "agreement",
          "queryContractKeyword",
          1,
          1
        );
        this.getList(
          "",
          "sellerNameOptions",
          "agreement",
          "queryContractKeyword",
          2,
          1
        );
      },
      getDicContractBusType() {
        this.busTypeOption = [];
        $api.other.getContractBusTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.note),
              };
              this.busTypeOption.push(obj);
            });
          });
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      maxTagPlaceholder(num) {
        return "更多+ " + num;
      },
      remoteMethod(query, options, url, path, columnType, moduleType) {
        if (query !== "") {
          this.searchLoading = true;
          this.getList(query, options, url, path, columnType, moduleType);
        } else {
          this[options] = [];
        }
      },
      async getList(query, options, url, path, columnType, moduleType) {
        let params = {
          columnType: columnType,
          moduleType: moduleType,
        };

        if (!isEmpty(query)) {
          params.keyword = query;
        }
        if (isEmpty(this[options])) {
          this.searchLoading = true;
        }
        let res = await $api[url].post(path, params);
        this.searchLoading = false;
        if (res.status === 1) {
          this[options] = res.data;
        }
      },
      setDefaultOptions(options, option) {
        this[option] = options;
      },
      getMap(row) {
        if (row.logisticsType === 1) {
          this.isCar = true;
          this.seeCarMap(row);
        } else {
          this.isCar = false;
          this.seeShipMap(row);
        }
      },
      seeCarMap(row) {
        let that = this;
        this.trackFlag = true;
        this.url = '/carShip/fwCarFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow;
            iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
          }, 5000);
        });
      },
      seeShipMap(row) {
        let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
        if (mmsi == null || mmsi === "") {
          //暂无数据
          this.$Message.error("暂无数据");
          return;
        }
        let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
        let deliveryDates = moment(row.endTime).format("YYYY-MM-DD");
        let obj = {
          startTime: beginTime + " 00:00:00",
          endTime: deliveryDates + " 00:00:00",
          mmsi: mmsi,
        };
        this.trackFlag = true;
        let that = this;
        if (this.url === "/carShip/fwShipFrame") {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify(obj), "*");
        } else {
          this.url = "/carShip/fwShipFrame";
          this.$nextTick(function () {
            setTimeout(function () {
              let mapFrame = that.$refs.mapFrame;
              let iframeWin = mapFrame.contentWindow;
              iframeWin.postMessage(JSON.stringify(obj), "*");
            }, 5000);
          });
        }
      },
      // 船舶日期往前推N天
      dateAddDays(dataStr, dayCount) {
        let isdate = new Date(dataStr.replace(/-/g, "/"));
        isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
        let strMonth = isdate.getMonth() + 1;
        let strDate = isdate.getDate();
        let strYear = isdate.getFullYear();
        if (strMonth >= 1 && strMonth <= 9) {
          strMonth = "0" + strMonth;
        }
        if (strDate >= 1 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return strYear + "-" + strMonth + "-" + strDate;
      },
      refresh() {
        this.queryContractListByObj(this.paramsObj);
      },
      async download() {
        if (isEmpty(this.tableData)) {
          this.$XModal.message("暂无数据");
          return;
        }
        let params = this.paramsObj;
        params.type = 1;
        showLoading();
        let res = getBlob("/api/order/contract/exportContractList", params);
        hideLoading();
        await saveBlob("导出托运人合同.xls", res.data);
      },
      async queryContractList() {
        this.loading = true;
        let res = await $api.agreement.request("queryContractList", {
          type: 1,
          orderBy: 2,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          let contractData = res.data.rows;
          if (contractData && contractData.length > 0) {
            contractData.map((i) => {
              if (i.goodsList) {
                i.goodsName = i.goodsList[0].goodsName;
                i.unit = i.goodsList[0].unit;
                i.counts = i.goodsList[0].counts;
                i.price = i.goodsList[0].price;
                i.isTax = i.goodsList[0].isTax;
                i.carShipNum = i.goodsList[0].carShipNum;
                i.beginPlace = i.goodsList[0].beginPlace;
                i.endPlace = i.goodsList[0].endPlace;
                i.beginTime = i.goodsList[0].beginTime;
                i.addTime = i.goodsList[0].addTime;
                i.endTime = i.goodsList[0].endTime;
                i.transportationType = i.goodsList[0].transportationType;
                i.packUnit = i.goodsList[0].packUnit;
                i.priceType = i.goodsList[0].priceType;
                i.amount = i.goodsList[0].amount;
              }
            });
          }
          this.tableData = contractData;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async queryContractListByObj(obj) {
        this.loading = true;
        let res = await $api.agreement.request("queryContractList", obj);
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          let contractData = res.data.rows;
          if (contractData && contractData.length > 0) {
            contractData.map((i) => {
              if (i.goodsList) {
                i.goodsName = i.goodsList[0].goodsName;
                i.unit = i.goodsList[0].unit;
                i.counts = i.goodsList[0].counts;
                i.price = i.goodsList[0].price;
                i.isTax = i.goodsList[0].isTax;
                i.carShipNum = i.goodsList[0].carShipNum;
                i.beginPlace = i.goodsList[0].beginPlace;
                i.endPlace = i.goodsList[0].endPlace;
                i.beginTime = i.goodsList[0].beginTime;
                i.addTime = i.goodsList[0].addTime;
                i.endTime = i.goodsList[0].endTime;
                i.transportationType = i.goodsList[0].transportationType;
                i.packUnit = i.goodsList[0].packUnit;
                i.priceType = i.goodsList[0].priceType;
                i.amount = i.goodsList[0].amount;
              }
            });
          }
          this.tableData = contractData;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      getSearchListKey() {
        let obj = this.searchFormData;
        let paramsObj = {};
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] !== null &&
            key !== "createTime" &&
            key !== "addTime" &&
            obj[key] !== undefined
          ) {
            paramsObj[key] = obj[key];
          }
          if (obj["createTime"] && obj["createTime"].length > 0) {
            paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
            paramsObj.createTimeEnd =
              moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["addTime"] && obj["addTime"].length > 0) {
            paramsObj.addTimeBegin = moment(obj.addTime[0]).valueOf(); // 开始时间
            paramsObj.addTimeEnd = moment(obj.addTime[1]).valueOf() + 86399999; // 结束时间
          }
        });
        paramsObj.page = 1;
        paramsObj.rows = this.page.pageSize;
        paramsObj.type = 1;
        paramsObj.orderBy = 2;
        if (this.searchBuyerName.length > 0) {
          paramsObj.buyerName = this.searchBuyerName[0];
        }
        if (this.searchSellerName.length > 0) {
          paramsObj.sellerName = this.searchSellerName[0];
        }
        this.paramsObj = paramsObj;
        this.page.currentPage = 1;
        this.page.pageSize = 10;
        this.queryContractListByObj(paramsObj);
        this.searchVisible = false;
      },
      commitDelete(id) {
        this.$XModal.confirm("您确定要删除吗？").then((type) => {
          if (type === "confirm") {
            this.deleteContract(id);
          }
        });
      },
      async deleteContract(id) {
        let res = await $api.agreement.request("removeContract", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.queryContractListByObj(this.paramsObj);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changePage(e) {
        if (this.paramsObj) {
          this.paramsObj.page = e.currentPage;
          this.paramsObj.rows = e.pageSize;
          this.queryContractListByObj(this.paramsObj);
        } else {
          this.page.currentPage = e.currentPage;
          this.page.pageSize = e.pageSize;
          this.queryContractList();
        }
      },
      showDialog() {
        this.modalTitle = "新增托运人合同";
        this.visible = true;
        this.$refs.modalCreate.$refs.saleHeader.init();
      },
      openEditView(id) {
        if (!this.isHavePermission('buyer:queryContractDetail')) {
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return;
        }
        this.modalTitle = "编辑托运人合同";
        this.visible = true;
        this.$refs.modalCreate.queryContractDetail(id);
        this.$refs.modalCreate.$refs.saleHeader.init();
      },
      goEdit() {
        this.modalTitle = "编辑托运人合同";
        this.visible = true;
        this.$refs.modalCreate.queryContractDetail(this.contractId);
        this.$refs.modalCreate.$refs.saleHeader.init();
      },
      showDetail(id) {
        this.contractId = id;
        this.viewBuyer = true;
        if (!this.isHavePermission('buyer:queryContractDetail')) {
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return;
        }
        this.$refs.modalDetail.queryContractDetail(id);
        this.$nextTick(() => {
          this.$refs.modalDetail.setEditor(
            this.isHavePermission("buyer:updateContract")
          );
        });
      },
      clickEvent3(rowIndex) {
        this.$refs[rowIndex].togglePanel();
      },
      close(value) {
        if (value === "add") {
          this.visible = false;
        } else if (value === "update") {
          this.visible = false;
          this.viewBuyer = false;
          this.$refs.modalDetail.close();
        }
        this.queryContractListByObj(this.paramsObj);
      },
      closeCreate() {
        this.$refs.modalCreate.close();
      },
      closeDetail() {
        this.$refs.modalDetail.close();
      },
    },
  };
</script>

<style>
  .btn-down {
    border: none;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
    background: transparent;
  }

  .page-con-header {
    margin-bottom: 10px;
    position: relative;
  }

  .btn-down.ivu-btn {
    background: transparent;
  }

  .btn-down.ivu-btn:hover {
    background: transparent;
  }

  .trackBox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 100;
    background: #fff;
  }
</style>
